export const TOPBAR_HEIGHT = "6.4rem";
export const SIDEBAR_WIDTH = "23.5rem";

export const statusColor = (status) => {
  switch (status) {
    case true:
      return "accents.200";
    case false:
      return "accents.100";
    default:
      return "accents.200";
  }
};
